import { createFileRoute } from '@tanstack/react-router';
import { isPermissionFull } from '@/features/login/util/permission';
import { validateRoute } from '@/router/util';

export const Route = createFileRoute('/a/renegociacao/contas-receber')({
    beforeLoad: () =>
        validateRoute({
            fintech: true,
            validatePermission: ({ upp_financeiro_conta_receber }) =>
                isPermissionFull(upp_financeiro_conta_receber),
        }),
});
